// extracted by mini-css-extract-plugin
export default {"nextStepBtn":"passengers-list_nextStepBtn__jn98y","tableContainer":"passengers-list_tableContainer__9zHgz"};